import React, { useEffect, useState } from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import { ElementHTML } from '@helpers/helper.rendering'
import { navigate } from 'gatsby'

const Contact_3 = (props: RealEstateDataPageComponentData) => {
  const { title, titleElement, button } = props
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    <section className="p-y-config">
      {isMounted ? (
        <>
          <Container
            fluid
            className="w-75 d-flex align-items-center"
            style={{ height: '30vh' }}
          >
            <Row className="w-100">
              {title ? (
                <Col
                  xs={12}
                  lg={4}
                >
                  {title && (
                    <ElementHTML
                      children={title || ''}
                      elementType={titleElement || 'h2'}
                      className="text-start mb-5 mb-lg-0 mt-lg-3"
                    />
                  )}
                  <button
                    className="btn btn-primary mt-3"
                    onClick={() => navigate(button?.link ?? '/')}
                  >
                    {button?.value ?? 'Contactanos'}
                  </button>
                </Col>
              ) : null}
            </Row>
          </Container>
        </>
      ) : (
        <></>
      )}
    </section>
  )
}

export default Contact_3
